// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu p a{color:#00229b;text-decoration:none;font-size:.95rem;font-weight:700}.container{max-width:800px!important}iframe{width:100%;scrollbar-width:20px}.sozlesmecheck{color:red;font-size:1rem}input[type=checkbox]{border-color:red}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
